import { render, staticRenderFns } from "./VideoFilePlayerView.vue?vue&type=template&id=b2a999b0&scoped=true&"
import script from "./VideoFilePlayerView.vue?vue&type=script&lang=js&"
export * from "./VideoFilePlayerView.vue?vue&type=script&lang=js&"
import style0 from "./VideoFilePlayerView.vue?vue&type=style&index=0&id=b2a999b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a999b0",
  null
  
)

export default component.exports